// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pj-1";
export var messageSideRight = "_pj-2";
export var subscribeToBackInStockBubbleContainer = "_pj-0";